import React, {useContext, useEffect, useState, Fragment} from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import {BaseUrl} from "../../../contexts/baseUrl/baseUrl";
import Layout from "../../../components/sales/layout/layout";
import ListFilters from "components/sales/ListFilters/ListFilters";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";

const UCDListing = ({
    match,
    ucdListRequest,
    ucdListResponse = []
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const [userId, setUserId] = useState()
    const [filterData, setFilterData] = useState(null);
    const [showFilter, setShowFilter] = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            setUserId(JSON.parse(window.localStorage.loginDetails)?.id)
            await ucdListRequest(1)
            setIsLoading(false)
        })()
    }, [])

    const headers = [
        'Business Name',
        'Channel Type',
        'Organization Type',
        'Pan No',
        'Bank Name',
        'Mobile No',
        'Created By',
        'Action'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await ucdListRequest(val.selected + 1);
        setIsLoading(false);
    };

    useEffect(() => {
        setListData([])
        const actions = [
            { name: 'View Details', link: `${baseUrl}/ucd/view` },
            { name: 'Add New Case', link: `${baseUrl}/ucd/case-add` },
            { name: 'Case List', link: `${baseUrl}/ucd/case-list` },
        ];
        if (ucdListResponse &&
            ucdListResponse?.data !== undefined && ucdListResponse?.data.length > 0) {
            const tableData = ['id', 'business_name', 'channel_type', 'organization_type', 'dealer_pan_no', 'bank_name', 'registration_mobile_no', 'name'];
            const data = ucdListResponse?.data.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        {[key]: element[key]}
                    )),
                    {Action: [
                            { name: 'View Details', link: `${baseUrl}/ucd/view` },
                            (parseInt(element['vendor_status']) === 2 && parseInt(userId) === 886) ?
                            { name: 'Add New Case', link: `${baseUrl}/ucd/case-add/B2B/` } : "",
                            (parseInt(element['vendor_status']) === 2) ?
                            { name: 'Case List', link: `${baseUrl}/ucd/case-list/${element['dealer_id']}` } : ""
                        ]},
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(ucdListResponse.total / ucdListResponse.per_page));
        }
    }, [ucdListResponse])

    const applyFilter = async (filterData) => {
        setIsLoading(true);
        localStorage.setItem('filterData', JSON.stringify(filterData));
        setFilterData(filterData);
        await ucdListRequest(1, filterData?.business_name);
        setIsLoading(false);
        filterToggle();
      };

    const filterToggle = () => {
        setShowFilter(!showFilter);
      };
    
      const headerBtns = () => {
        return (
          <Fragment>
            <Button
              onClick={filterToggle}
              className="filter-hamburger btn btn-transparent"
            >
              <img src={Images?.Filter} alt=""></img>
              {localization.showFilters}
            </Button>
          </Fragment>
        );
      };
    
    return (
        <>
            <Layout
                title={"Dealer Listing"}
                isLoading={isLoading}
                isGoback={true}
                Buttons={headerBtns}
            >
            <TableSection
                data={listData}
                isId={false}
                isMngId={false}
                headers={headers}
                pageCount={pageCount}
                onPageChange={onPageChange}
                detailList={ucdListResponse && ucdListResponse?.data}
                srNo={ucdListResponse?.from}
            />
            <ListFilters
                showFilter={showFilter}
                filterToggle={filterToggle}
                applyFilter={(val) => applyFilter(val)}
                ucdFilter
            />
            </Layout>
        </>
    )
}

export default UCDListing

